import React from 'react';

import Box from '@mui/material/Box';

import { CustomInputWithOutIcon } from './CustomInput';
import { SelectProfileUser } from './Select/CustomSelect';

export const InputSelectWithOutIcon = ({
  label, 
  id, 
  children, 
  value, 
  setValue, 
  defaultValue, 
  isMobile, 
  renderValue,
  direction
}) => {


  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }, 
    label: {
      whiteSpace: 'normal',
      color: '#000000'
    },
    iconDropdown: {
      paddingRight : '.5em',
    },
    select: {
      width: '100%', 
      borderRadius: '0.5em', 
      display:'flex', 
    },
    menuList: {
      display: 'flex',
      width: '100%',
      // padding: '0.5em', 
      justifyContent: 'space-around', 
      backgroundColor: 'secondary.main'
    },
  };

  return (
    <CustomInputWithOutIcon 
      id={id} 
      label={label}
      styleLabel={styles.label}
      direction={direction}
    >
      <Box sx={styles.container}>
        <SelectProfileUser 
          id={id}
          labelId={id}
          value={value}
          defaultValue={defaultValue}
          onChange={setValue}
          sx={styles.select}
          renderValue={renderValue}
          size={isMobile ? 'small' : 'medium'}
          MenuProps={{
            id: `${id}_options` ,
            sx: {
              '& .MuiMenu-paper': {
                display: 'flex',
                left: isMobile ? '0.5em !important' : null,
                backgroundColor: 'inherit',
              }
            },
            elevation: 0,
            MenuListProps: {sx: styles.menuList},
          }}
          inputProps={{
            sx: {
              color: '#000000'
            }
          }}
        >
          {children}
        </SelectProfileUser>
      </Box>
    </CustomInputWithOutIcon>
  );
};